import React from 'react';
import c from 'classnames';
import { history } from 'instantsearch.js/es/lib/routers';
import {
  SearchkitWrapper,
  SearchStats,
  SearchPagination,
} from '@uncinc/react-searchkit';
import { DEFAULT_REQUEST_OPTIONS } from '@uncinc/react-searchkit/dist/config/constants';

import {
  resultAttributes,
  searchAttributes,
  facetAttributes,
  sorting,
} from './config';

import {
  SEARCHKIT_HOST_URL,
  APP_OPTIONS,
} from '../../config/constants';

import SearchResults from './SearchResults';
import SearchBar from './SearchBar';
import SearchMaatjesProjectsFacets from './Facets';

const SEARCH_ITEMS_PER_PAGE = 10;

const SearchMaatjesProjects = (props) => {
  const {
    className,
    children,
    ...restProps
  } = props;

  const classNames = c('SearchMaatjesProjects', className);
  const requestOptions = {
    ...DEFAULT_REQUEST_OPTIONS,
  };

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={APP_OPTIONS.parameters.searchkitIndexAlLProjects}
      hitsPerPage={SEARCH_ITEMS_PER_PAGE}
      searchSettings={{
        search_attributes: searchAttributes,
        result_attributes: resultAttributes,
        facet_attributes: facetAttributes,
        sorting,
      }}
      requestOptions={requestOptions}
      routing={{
        router: history({
          writeDelay: 0,
        }),
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchMaatjesProjects.SearchBar = SearchBar;
SearchMaatjesProjects.SearchFacets = SearchMaatjesProjectsFacets;
SearchMaatjesProjects.SearchStats = SearchStats;
SearchMaatjesProjects.SearchPagination = SearchPagination;
SearchMaatjesProjects.SearchResults = SearchResults;

export default SearchMaatjesProjects;
